import { isEmail } from '../../src/utils/validations';
import { checkEmail } from '../email-suggestion/email-suggestion';

(() => {
  const signUpForm = document.getElementById('sign-up-form');

  const formEmail = document.getElementById('session_email');
  const formPassword = document.getElementById('session_password');
  const formCheckbox = document.getElementById('session_cgu_param_accepted');

  function emailIsValid() {
    return formEmail.value && isEmail(formEmail.value);
  }

  function passwordIsValid() {
    return formPassword.value && formPassword.value.length >= 6;
  }

  function cguChecked() {
    return formCheckbox.checked;
  }

  function signUpFormIsValid() {
    return emailIsValid() && passwordIsValid() && cguChecked();
  }

  function handleOnClickSuggestion(suggestion) {
    formEmail.value = suggestion;
  }

  if (formEmail) {
    formEmail.addEventListener('blur', () =>
      checkEmail(formEmail.value, formEmail, handleOnClickSuggestion)
    );
  }

  if (gon.app_env === 'production' && signUpForm) {
    signUpForm.addEventListener('submit', () => {
      if (signUpFormIsValid() && gon.accepted_cookies) {
        fbq('track', 'CompleteRegistration', { content_name: 'Signed up' });
      }
    });
  }
})();
